import { change } from 'redux-form';
import {
	MOBILE_SETTINGS_UPLOAD_START,
	MOBILE_SETTINGS_UPLOAD_ERROR,
	MOBILE_SETTINGS_UPLOAD_SUCCESS
} from '../../constants/index'
import { setLoaderStart, setLoaderComplete } from '../loader/loader'
import { api } from '../../config';
import { showToaster } from '../../helpers/toastrMessgaes/showToaster';
import { updateMobileSettingsMutation as mutation, updateToneMutation } from '../../lib/graphql';

const updateMobileSettings = ({
	appForceUpdate,
	userAndroidVersion,
	userIosVersion,
	partnerAndroidVersion,
	partnerIosVersion,
	stripePublishableKey,
	allowableDistace,
	allowedServices,
	notificationInterval,
	sleepPartnerAndroid,
	sleepPartnerios,
	contactPhoneNumber,
	contactEmail,
	skype,
	maximumEmergencyContact,
	duration,
	job,
	photo,
	description,
	estimatedPrice,
	location,
	requestTimeTone,
	isRequestTimerToneEnable,
	openAppOnRequest,
	requestToneFile,
	defaultScheduleInterval,
	addtionalWorkInterval
}) => {

	try {
		return async (dispatch, getState, { client }) => {
			
			dispatch({ type: MOBILE_SETTINGS_UPLOAD_START });
			
			dispatch(setLoaderStart('MobileSettings'));

			const { data } = await client.mutate({
				mutation,
				variables: {
					appForceUpdate,
					userAndroidVersion,
					userIosVersion,
					partnerAndroidVersion,
					partnerIosVersion,
					stripePublishableKey,
					allowableDistace,
					allowedServices,
					notificationInterval,
					sleepPartnerAndroid,
					sleepPartnerios,
					contactPhoneNumber,
					contactEmail,
					skype,
					maximumEmergencyContact,
					duration,
					job,
					photo,
					description,
					estimatedPrice,
					location,
					requestTimeTone,
					isRequestTimerToneEnable,
					openAppOnRequest,
					requestToneFile,
					defaultScheduleInterval,
					addtionalWorkInterval
				}
			});

			
			if (data?.updateMobileSettings?.status == 200) {
				dispatch({ type: MOBILE_SETTINGS_UPLOAD_SUCCESS });
				showToaster({ messageId: 'mobileSettingsSuccess', toasterType: 'success' });
			}
			else {
				let errorMessage = data?.updateMobileSettings?.errorMessage || 'Something went wrong';
				dispatch({ type: MOBILE_SETTINGS_UPLOAD_ERROR });
				showToaster({ messageId: 'errorMessage', requestContent: { content: errorMessage }, toasterType: 'error' });
			}
			dispatch(setLoaderComplete('MobileSettings'));
		}
	}
	catch (error) {
		dispatch({ type: MOBILE_SETTINGS_UPLOAD_ERROR });
		dispatch(setLoaderComplete('MobileSettings'));
		showToaster({ messageId: 'catchMessage', requestContent: { content: error }, toasterType: 'error' });
	}
}

const deleteTone = (fileName) => {
	return async (dispatch, getState, { client }) => {

		try {

			dispatch({
				type: MOBILE_SETTINGS_UPLOAD_START
			})

			dispatch(change("MobileSettingsForm", "requestTimeTone", null));

			const url = api.apiEndpoint + "/deleteTone";
			const resp = await fetch(url, {
				method: 'post',
				headers: {
					Accept: 'application/json',
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ fileName }),
			});

			const { status } = await resp.json();

			if (status == 200) {

				const { data } = await client.mutate({
					mutation: updateToneMutation
				})

				dispatch({
					type: MOBILE_SETTINGS_UPLOAD_SUCCESS
				})

			} else {
				dispatch({
					type: MOBILE_SETTINGS_UPLOAD_ERROR
				})
			}
		} catch (err) {
			dispatch({
				type: MOBILE_SETTINGS_UPLOAD_ERROR
			})
			showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
			return true;
		}
	}
}

export {
	updateMobileSettings,
	deleteTone
};